export const model = {
    id: null,
    user_id: '',
    branch_id: "",
    created_at: '',
    updated_at: ''
};
